import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { roomExit_WS } from 'store/features/event/actions/room.actions';

import { submitAnswers } from './actions';
import { answerRestored, clearAnswers } from './answers.slice';
import { clearQuestionAssignment, setActiveAnswerId } from './questionAssignment.slice';
import { selectAnswer, selectQuestionActiveAnswerId } from './selectors';

import type { RootState } from 'store';

export const questionsListener = createListenerMiddleware<RootState>();

questionsListener.startListening({
  matcher: isAnyOf(roomExit_WS, submitAnswers.fulfilled, submitAnswers.rejected),
  effect: (_, { dispatch }) => {
    dispatch(clearAnswers());
    dispatch(clearQuestionAssignment());
  },
});

// A failed create restored to nothing must not leave its edit input open.
questionsListener.startListening({
  actionCreator: answerRestored,
  effect: ({ payload: { id } }, { dispatch, getState }) => {
    const state = getState();
    if (selectQuestionActiveAnswerId(state) === id && !selectAnswer(state, id)) dispatch(setActiveAnswerId(undefined));
  },
});
